export enum TASK_STATUS_ENUM {
  TODO = 'TODO',
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE',
  DEFERRED = 'DEFERRED',
}

export enum TASK_PRIORITY_ENUM {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}
